"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListEventType = void 0;
var WaitListEventType;
(function (WaitListEventType) {
    WaitListEventType["WaitListRewardSet"] = "WaitListRewardSet";
    WaitListEventType["WaitListRewardClaimed"] = "WaitListRewardClaimed";
})(WaitListEventType || (exports.WaitListEventType = WaitListEventType = {}));
//# sourceMappingURL=waitlist.js.map